import { useState } from 'react';
import ClipLoader from 'react-spinners/ClipLoader';

export default function CreateTecnicoModal({ onSubmit, onClose }) {
  const [formData, setFormData] = useState({
    email: '',
    nome: '',
    cognome: '',
    telefono: '',
  });
  const [saving, setSaving] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (saving) return;
    try {
      setSaving(true);
      // onSubmit è async nel tuo uso → il loader resta attivo finché non termina
      await onSubmit(formData);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-3 p-4 bg-slate-50" aria-busy={saving}>
      <input
        type="text"
        name="nome"
        placeholder="Nome"
        value={formData.nome}
        onChange={handleChange}
        className="w-full p-2 border rounded disabled:opacity-60"
        disabled={saving}
      />
      <input
        type="text"
        name="cognome"
        placeholder="Cognome"
        value={formData.cognome}
        onChange={handleChange}
        className="w-full p-2 border rounded disabled:opacity-60"
        disabled={saving}
      />
      <input
        type="email"
        name="email"
        placeholder="Email"
        value={formData.email}
        onChange={handleChange}
        className="w-full p-2 border rounded disabled:opacity-60"
        disabled={saving}
      />
      {/* La password verrà impostata dall'utente via link di attivazione */}
      <input
        type="text"
        name="telefono"
        placeholder="Telefono"
        value={formData.telefono}
        onChange={handleChange}
        className="w-full p-2 border rounded disabled:opacity-60"
        disabled={saving}
      />

      <div className="flex justify-end gap-2 pt-2">
        <button
          onClick={handleSubmit}
          disabled={saving}
          className="relative bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700
                     disabled:opacity-60 disabled:cursor-not-allowed"
        >
          {saving && (
            <span className="absolute inset-0 flex items-center justify-center">
              <ClipLoader size={18} color="#fff" />
            </span>
          )}
          <span className={saving ? 'invisible' : ''}>Salva</span>
        </button>

        <button
          onClick={onClose}
          disabled={saving}
          className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500
                     disabled:opacity-60 disabled:cursor-not-allowed"
        >
          Annulla
        </button>
      </div>
    </div>
  );
}
